'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Map = require('../GoogleMaps/Map');

var _Map2 = _interopRequireDefault(_Map);

var _Marker = require('../GoogleMaps/Marker');

var _Marker2 = _interopRequireDefault(_Marker);

var _createMapIcon = require('../CreateMapIcon/createMapIcon');

var _createMapIcon2 = _interopRequireDefault(_createMapIcon);

var _Utils = require('@wix/wixrest-utils/dist/Utils');

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createReactClass2.default)({

    displayName: 'Shared.StaticMap',

    propTypes: {
        width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        organization: _propTypes2.default.object.isRequired,
        order: _propTypes2.default.object.isRequired,
        displayLanguage: _propTypes2.default.string,
        allowPointerEvents: _propTypes2.default.bool,
        disableDefaultUI: _propTypes2.default.bool,
        hideMapMarker: _propTypes2.default.bool,
        numberedPinLabels: _propTypes2.default.bool,
        googleMapStyles: _propTypes2.default.array,
        showRoute: _propTypes2.default.bool
    },

    defaultProps: {
        googleMapStyles: [],
        allowPointerEvents: false,
        disableDefaultUI: true,
        numberedPinLabels: false,
        showRoute: false
    },

    getInitialState: function getInitialState() {
        return {
            width: 0,
            height: 0
        };
    },
    render: function render() {
        var _props = this.props,
            organization = _props.organization,
            order = _props.order,
            width = _props.width,
            height = _props.height,
            allowPointerEvents = _props.allowPointerEvents,
            disableDefaultUI = _props.disableDefaultUI,
            zoom = _props.zoom,
            numberedPinLabels = _props.numberedPinLabels;
        var _state = this.state,
            stateWidth = _state.width,
            stateHeight = _state.height;


        var style = {
            minHeight: height,
            minWidth: width,
            position: 'relative',
            pointerEvents: allowPointerEvents ? 'all' : 'none'
        };

        if (!stateWidth || !stateHeight) {
            return _react2.default.createElement('div', { className: 'openrest_Shared_StaticMap_wrapper', style: style });
        }

        var locale = (organization || order || {}).locale;
        var address = _lodash2.default.get(organization, 'address') || _lodash2.default.get(order, 'delivery.address');
        var markers = [];
        var bounds = [];

        var renderOrganizationPin = organization && organization.address;
        var renderCustomerPin = order && order.delivery && order.delivery.address;
        var has2Pins = renderOrganizationPin && renderCustomerPin;
        var getLabelProp = function getLabelProp(number) {
            return numberedPinLabels && has2Pins && { label: number };
        };

        if (renderOrganizationPin) {
            markers.push(_react2.default.createElement(_Marker2.default, (0, _extends3.default)({}, getLabelProp('1'), { icon: (0, _createMapIcon2.default)({ template: "restPin" }), position: organization.address.latLng, key: 'organizationmarker' })));
            bounds.push(organization.address.latLng);
        }

        if (renderCustomerPin) {
            markers.push(_react2.default.createElement(_Marker2.default, (0, _extends3.default)({}, getLabelProp('2'), { icon: (0, _createMapIcon2.default)({ template: "customerPin" }), position: order.delivery.address.latLng, key: 'ordermarker' })));
            bounds.push(order.delivery.address.latLng);
        }

        var mapStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
        };

        var mapParams = (0, _extends3.default)({
            className: 'map',
            showRoute: this.props.showRoute,
            style: mapStyle,
            center: address.latLng,
            styles: this.props.googleMapStyles,
            disableDefaultUI: disableDefaultUI,
            locale: locale
        }, getPanParams({ width: stateWidth, height: stateHeight, bounds: bounds }));

        if (zoom) {
            // Override value calculated by getPanParams if explicitly specified
            mapParams.zoom = zoom;
        }

        return _react2.default.createElement(
            'div',
            { className: 'openrest_Shared_StaticMap_wrapper', title: 'map', style: style, 'aria-hidden': 'true' },
            _react2.default.createElement(
                _Map2.default,
                mapParams,
                !this.props.hideMapMarker && markers
            )
        );
    },
    componentDidMount: function componentDidMount() {
        this.componentDidUpdate();
    },
    componentDidUpdate: function componentDidUpdate() {
        var wrapper = _reactDom2.default.findDOMNode(this);
        var boundingClientRect = wrapper.getBoundingClientRect();

        if (boundingClientRect.width !== this.state.width || boundingClientRect.height !== this.state.height) {
            this.setState({
                width: boundingClientRect.width,
                height: boundingClientRect.height
            });
        }
    }
});


function getPanParams(_ref) {
    var width = _ref.width,
        height = _ref.height,
        bounds = _ref.bounds;

    if (!width || !height) return {};

    var mapSize = { width: width, height: height };

    var boundsLatLng = new google.maps.LatLngBounds();
    _lodash2.default.each(bounds, function (point) {
        boundsLatLng.extend(new google.maps.LatLng(point.lat, point.lng));
    });

    // if we have only one pin, like in pickup we want to have zoom = 14
    var zoom = bounds.length > 1 ? _Utils2.default.getBoundsZoomLevel(boundsLatLng, mapSize) - 1 : 14;

    var panTo = {
        lat: boundsLatLng.getCenter().lat(),
        lng: boundsLatLng.getCenter().lng()
    };

    return { center: panTo, zoom: zoom };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-components/dist/web/StaticMap/StaticMap.js
// module id = 1155
// module chunks = 0